export const GET_CAMPAIGN_INFO_DATA = "GET_CAMPAIGN_INFO_DATA";
export const GET_CAMPAIGN_INFO_SUCCESS = "GET_CAMPAIGN_INFO_SUCCESS";
